export default __webpack_public_path__ + "static/media/table.1377abe5.svg";